<p-card header="Change Log">
  <div>
    @if (logsLoading()) {
      <cor-skeleton [type]="SKELETON_TYPES.HISTORY" />
    }
    <dx-data-grid
      corGridSearch
      corGridSearchLocation="after"
      [dataSource]="store()"
      [showBorders]="true"
      [showColumnLines]="false"
      [hoverStateEnabled]="true"
      [scrolling]="{ useNative: true }"
      [columns]="columns"
      [allowColumnResizing]="true"
      columnResizingMode="widget"
      [allowColumnReordering]="true"
      [visible]="!logsLoading()">
      <dxo-data-grid-pager
        [showPageSizeSelector]="true"
        [allowedPageSizes]="[10, 20, 50]"
        [showNavigationButtons]="true"
        [showInfo]="true" />
      <dxo-data-grid-load-panel [enabled]="!logsLoading()" />
      <dxo-data-grid-header-filter
        [visible]="true"
        height="50vh"
        width="100%"
        [search]="{ enabled: true }" />
      <dxo-data-grid-toolbar>
        <dxi-data-grid-item location="before">
          <p-selectbutton
            test-id="change-log-p-selectbutton"
            [options]="[
              { label: 'All', value: 'all' },
              { label: 'Named Snapshots', value: 'named' },
            ]"
            [(ngModel)]="logsFilter"
            optionLabel="label"
            optionValue="value" />
        </dxi-data-grid-item>
      </dxo-data-grid-toolbar>
      <!-- Column Templates -->
      <div *dxTemplate="let row of 'dateTemplate'">
        {{ row.value | localDate }}
      </div>
      <div *dxTemplate="let row of 'avatarTemplate'">
        <div class="tw:flex tw:items-center tw:gap-2">
          <p-avatar
            class="tw:shrink-0 tw:w-[1.5rem] tw:h-[1.5rem] tw:text-xs"
            [label]="row.value | nameBadge"
            [ngStyle]="{
              backgroundColor: (row.value | uniqueRgbColor),
              color: 'white',
            }"
            shape="circle" />
          <span>
            {{ row.value }}
          </span>
        </div>
      </div>
      <div *dxTemplate="let row of 'changeMessageTemplate'">
        <!-- Note: We use title instead of tooltip as tooltip was causing issues with the layout
                     of the table -->
        @if (row.data.comment) {
          <div class="tw:truncate">
            <i>Comment</i>
            :
            <span [title]="row.data.comment">{{ row.data.comment }}</span>
          </div>
        }
        <div
          class="tw:truncate"
          [title]="row.value">
          {{ row.value }}
        </div>
      </div>

      <!-- Row Template -->
      <div *dxTemplate="let row of 'actionTemplate'">
        <div class="tw:flex tw:items-center tw:justify-end tw:gap-1">
          @if (snapshotChanges.showButton() && row.data.action !== 'Created') {
            <p-button
              test-id="change-log-view-definition-changes-from-previous-sn"
              [buttonProps]="{ autofocus: false }"
              variant="text"
              severity="secondary"
              icon="pi pi-eye"
              pTooltip="View definition changes from previous snapshot"
              tooltipPosition="left"
              (click)="snapshotChanges.onShow(row.data)" />
          }
          @if (
            (row.data.latestLogId === row.data.id ? latestChangeLogOptions : changeLogOptions)
              .length > 0
          ) {
            <p-button
              test-id="change-log-log-menu-toggle"
              [buttonProps]="{ autofocus: false }"
              type="button"
              (click)="logMenu.toggle($event)"
              rounded
              variant="text"
              severity="secondary"
              icon="pi pi-ellipsis-v" />

            <p-menu
              #logMenu
              [style]="{ width: '15rem' }"
              [model]="row.data.menuItems"
              appendTo="body"
              [popup]="true" />
          }
        </div>
      </div>
    </dx-data-grid>
    <!-- Refered job-history.component -->
  </div>
</p-card>
<p-dialog
  [(visible)]="isVisible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="true"
  appendTo="body"
  header="Edit Snapshot Name"
  styleClass="tw:w-[50vw]">
  @if (saveLogVersionNameForm) {
    <form
      [formGroup]="saveLogVersionNameForm"
      (ngSubmit)="onVersionNameSubmit()">
      <div class="row">
        <div class="col-12">
          <cor-input-container
            label="Snapshot Name"
            test-id="snapshot-name">
            <input
              test-id="change-log-version-name"
              pInputText
              type="text"
              [fluid]="true"
              placeholder="Enter a name for Change Log"
              [formControl]="saveLogVersionNameForm.controls.versionName" />
          </cor-input-container>
        </div>
      </div>
    </form>
  }
  <ng-template #footer>
    <div class="tw:flex tw:gap-2 tw:items-center">
      <p-button
        test-id="change-log-cancel"
        [buttonProps]="{ autofocus: false }"
        (click)="isVisible.set(false)"
        severity="secondary"
        label="Cancel" />
      <p-button
        test-id="change-log-save-changes"
        [buttonProps]="{ autofocus: false }"
        [loading]="isSaving()"
        (click)="onVersionNameSubmit()"
        type="submit"
        [label]="isSaving() ? 'Saving...' : 'Save Changes'" />
    </div>
  </ng-template>
</p-dialog>

<!-- Snapshot diff dialog -->
<p-dialog
  [(visible)]="snapshotChanges.isVisible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="true"
  appendTo="body"
  header="Snapshot Changes"
  styleClass="tw:w-[80vw]">
  @if (snapshotChanges.isVisible()) {
    @if (snapshotChanges.isLoading()) {
      <cor-skeleton [type]="SKELETON_TYPES.SM_DETAILS" />
    } @else {
      @if (
        object() === OBJECTS.PROMPT &&
        (snapshotChanges.oldSnapshot().promptTemplate ||
          snapshotChanges.newSnapshot().promptTemplate)
      ) {
        <label>Prompt Template</label>
        <cor-diff-viewer
          [leftValue]="snapshotChanges.oldSnapshot().promptTemplate"
          [rightValue]="snapshotChanges.newSnapshot().promptTemplate"
          leftTitle="Previous Snapshot"
          rightTitle="Current Snapshot"
          language="python" />
      }
      @if (snapshotChanges.oldSnapshot().definition || snapshotChanges.newSnapshot().definition) {
        @if (object() === OBJECTS.PROMPT) {
          <label class="tw:mt-3">Prompt Creation Logic</label>
        } @else {
          <label class="tw:mt-3">Definition</label>
        }
        <cor-diff-viewer
          [leftValue]="snapshotChanges.oldSnapshot().definition"
          [rightValue]="snapshotChanges.newSnapshot().definition"
          leftTitle="Previous Snapshot"
          rightTitle="Current Snapshot"
          language="python" />
      }
    }
  }
</p-dialog>
